import GenericVModel from '@components/mixins/genericVModel'

export default {
  name: 'EditBlockNumericInput',
  mixins: [GenericVModel],
  props: {
    /**
     * the placeholder text
     */
    placeholder: {
      required: false,
      type: String,
      default: '',
    },
    min: {
      required: false,
      type: Number,
      default: 0,
    },
    max: {
      required: false,
      type: Number,
      default: 10,
    },
  },
}
